module.exports = __webpack_public_path__ + "img/avatar.a40cd940.png";